
import { defineComponent } from "vue";

export default defineComponent({
  name: "LogoComponent",
  components: {},

  props: {
    logo: {
      required: true,
      type: String,
    },
  },
});
